<template>
  <div
    class="gallery-collection-complete-container m-5 flex flex-col justify-center text-texts-standard-default"
    :class="{ 'lower-verion': lowerVersion }"
  >
    <div
      class="gallery-collection-complete-img m-6"
      :class="{'center-bg': isPicture}"
      :style="{
        backgroundImage: 'url(' + imgPath + ')',
      }"
    />

    <div v-if="!lowerVersion" class="congratulations-message text-28 flex-grow flexing m-8">
      {{
        $t(isCompleted ? 'gallery.collectionCompleted' : 'gallery.completeCollectionCTA')
      }}
    </div>

    <div class="rewards-title text-32 font-bold uppercase">
      {{ $t('gallery.rewardForCompletion') }}
    </div>

    <div class="rewards-container m-6">
      <app-scrollbar
        width="100%"
        height="100%"
        scroll="x"
        slice="x"
        class="flex"
        :class="rewards.length < 4 ? 'justify-center' : ''"
      >
        <div class="flexing">
          <reward-box
            v-for="(reward, index) in rewards"
            :key="index"
            :reward-icon="72"
            :reward-icon-name="reward.type"
            :reward-number="reward.value"
            class="flex-shrink-0"
            :class="isCompleted ? 'opacity-50' : ''"
          />
        </div>
      </app-scrollbar>
    </div>

    <div class="flexing m-10 rewards-collected-message">
      <div
        v-if="isCompleted"
        class="text-32 font-bold text-texts-standard-upgrade uppercase flexing"
      >
        {{ $t('gallery.rewardClaimed') }}
        <app-icon class="done ml-3" icon-name="done-sm" />
      </div>

      <app-button
        v-else
        btn-type="confirm"
        :btn-text="$t('gallery.claimReward')"
        btn-size="md"
        :disabled="!isClaimable"
        @click="$emit('claim-reward')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { pathImages } from '@/globalVariables'
import AppScrollbar from '../GlobalComponents/AppScrollbar.vue'
import RewardBox from '../GlobalComponents/RewardBox.vue'
import type Reward from '@/interfaces/Reward'
import AppButton from '../GlobalComponents/AppButton.vue'
import { type PropType } from 'vue'

interface ComponentData {
  pathImages: typeof pathImages
}

export default defineComponent({
  name: 'GalleryItemComplete',

  components: { AppScrollbar, RewardBox, AppButton },

  props: {
    lowerVersion: {
      type: Boolean,
      default: false,
    },
    
    isCompleted: {
      type: Boolean,
      default: false,
    },

    isClaimable: {
      type: Boolean,
      default: false,
    },

    rewards: {
      type: Array as PropType<Reward[]>,
      default: () => [],
    },

    isPicture: {
      type: Boolean,
      default: false
    },
    
    imgId: {
      type: Number,
      default: 0
    }
  },

  emits: ['claim-reward'],

  data(): ComponentData {
    return {
      pathImages,
    }
  },

  computed: {
    imgPath(): string {
      if (this.isPicture) {
        return `${pathImages}gallery/picture-thumbnail/gallery-picture-${this.imgId}-small.avif`
      }

      return `${pathImages}gallery/collection-collage/gallery-collection-${this.imgId}.avif`
    },
  }
})
</script>

<style lang="scss" scoped>
.gallery-collection-complete-container {
  background: url($path-images + 'gallery/bg-right-box.avif') no-repeat;
  background-size: cover;
  width: 29.375rem;
  height: calc(100% - 3rem);
  @if $isWsm {
    border: solid 0.125rem #5ba3dc;
  }
  @if $isSsm {
    border: solid 0.125rem #4c648f;
  }

  &.lower-verion {
    height: 38.4375rem;
  }

  .gallery-collection-complete-img {
    width: calc(100% - 3rem);
    height: 12.875rem;
    background-size: contain;
    background-repeat: no-repeat;

    &.center-bg {
      background-position-x: 5rem;
    }
  }

  .rewards-title {
    @if $isWsm {
      background-image: linear-gradient(
        90deg,
        rgba(108, 158, 196, 0) 0%,
        rgba(108, 158, 196, 0.8) 15%,
        rgba(108, 158, 196, 0.8) 85%,
        rgba(108, 158, 196, 0) 100%
      );
    }
    @if $isSsm {
      background-image: linear-gradient(
        90deg,
        rgba(86, 98, 127, 0) 0%,
        rgba(86, 98, 127, 0.8) 15%,
        rgba(86, 98, 127, 0.8) 85%,
        rgba(86, 98, 127, 0) 100%
      );
    }
  }

  .rewards-container {
    width: calc(100% - 3rem);
  }

  .done {
    width: 3.125rem;
    height: 3.125rem;
  }

  .rewards-collected-message {
    height: 5.75rem;
  }
}
</style>
